import React from 'react';
import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <div className="App">
      <div className="tech-grid-bg"></div>
      <Home />
    </div>
  );
}

export default App;